import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";

//import client from '../contentfulClientToken';

import { Link } from 'react-router-dom';

export default function Analog({ images }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isAllLoaded, setIsAllLoaded] = useState(false);
    const [loadedCount, setLoadedCount] = useState(0);
    const [randomPosition, setRandomPosition] = useState({ top: 0, left: 0 });
    const intervalRef = useRef(null);
    const [isFaded, setIsFaded] = useState(false);
    const [loadVersion, setLoadVersion] = useState(0);
    const countedIndicesRef = useRef(new Set());

    const handleMouseDownGradient = () => setIsFaded(true);
    const handleMouseUpGradient = () => setIsFaded(false);

    const startInterval = () => {
        // Start only if not already running
        if (intervalRef.current) return;
        if (images.length > 0) {
            intervalRef.current = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            }, 50);
        }
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };


    /* 
        const generateRandomPosition = () => {
            const randomTop = Math.random() * 80; // Limit within 80% of viewport height
            const randomLeft = Math.random() * 80; // Limit within 80% of viewport width
            setRandomPosition({ top: `${randomTop}vh`, left: `${randomLeft}vw` });
        }; */

    // Preloading and counting handled below

    useEffect(() => {
        if (isAllLoaded) {
            startInterval();
        }
        return () => stopInterval(); // Cleanup interval on unmount
    }, [isAllLoaded]);

    // Preload effect moved below after declarations

    const getImageUrl = useCallback((image) => {
        let width = 550; // default width
        if (windowWidth < 768) {
            width = 350; // width for mobile devices
        }
        let pixelRatio = window.devicePixelRatio || 1;
        pixelRatio = Math.min(pixelRatio, 2); // Cap the pixel ratio at 2
        let widthAdjusted = width * pixelRatio;
        return `https:${image.url}?w=${widthAdjusted}`;
    }, [windowWidth]);

    const imageUrls = useMemo(
        () => (images && images.length ? images.map((img) => getImageUrl(img)) : []),
        [images, getImageUrl]
    );
    const imageUrlsKey = useMemo(() => imageUrls.join("|"), [imageUrls]);

    const markIndexLoaded = useCallback((idx) => {
        if (idx == null) return;
        const set = countedIndicesRef.current;
        if (set.has(idx)) return;
        set.add(idx);
        setLoadedCount((prev) => {
            const next = prev + 1;
            if (next >= imageUrls.length) setIsAllLoaded(true);
            return next;
        });
    }, [imageUrls.length]);

    useEffect(() => {
        // reset loading state when URL list changes
        setLoadedCount(0);
        if (imageUrls.length > 0) {
            setIsAllLoaded(false);
        } else {
            setIsAllLoaded(true);
        }
        countedIndicesRef.current = new Set();
        setLoadVersion((v) => v + 1);
    }, [imageUrlsKey, imageUrls.length]);

    // Preload all images by URL and count by index
    useEffect(() => {
        if (imageUrls.length === 0) {
            setIsAllLoaded(true);
            return;
        }
        setIsAllLoaded(false);
        setLoadedCount(0);
        let cancelled = false;
        imageUrls.forEach((url, idx) => {
            const i = new Image();
            i.onload = () => { if (!cancelled) markIndexLoaded(idx); };
            i.onerror = () => { if (!cancelled) markIndexLoaded(idx); };
            i.src = url;
        });
        return () => { cancelled = true; };
    }, [imageUrlsKey, imageUrls, imageUrls.length, markIndexLoaded]);

    const handlePointerDown = (event) => {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
        stopInterval();
        // Ensure resume even if pointerup happens outside the container
        window.addEventListener('pointerup', handlePointerUp, { once: true });
        window.addEventListener('pointercancel', handlePointerUp, { once: true });
    };

    const handlePointerUp = (event) => {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
        startInterval();
    };

    return (
        <div id="analog">

            {/*        <div
                className={`gradient ${isFaded ? "faded" : ""}`}
            ></div> */}
            <div
                className="pictures-flashing-container"
                onPointerDown={handlePointerDown}
                onPointerUp={handlePointerUp}
                onPointerCancel={handlePointerUp}
                style={{ position: "relative" }}
            >
                {isAllLoaded && images.length > 0 &&
                    images.map((image, index) => {
                        const isCurrent = index === currentImageIndex;
                        return (
                            <img
                                key={`${index}-${loadVersion}`}
                                src={getImageUrl(image)}
                                alt={image.title}
                                style={{
                                    position: isCurrent ? "relative" : "absolute",
                                    opacity: isCurrent ? 1 : 0,
                                    visibility: isCurrent ? "visible" : "hidden",
                                    pointerEvents: isCurrent ? "auto" : "none",
                                    maxWidth: isCurrent ? undefined : "550px",
                                    maxHeight: isCurrent ? undefined : "80vh",
                                }}
                                onLoad={() => markIndexLoaded(index)}
                                onError={() => markIndexLoaded(index)}
                                draggable={false}
                            />
                        );
                    })}
                {isAllLoaded && images.length > 0 && (
                    <div className="current-image-title">
                        {images[currentImageIndex].title.split(" - ").map((part, i) => (
                            <p key={i}>{part}</p>
                        ))}
                    </div>
                )}

                {!isAllLoaded && (
                    <div
                        className="loading-indicator"
                        style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            pointerEvents: "none",
                        }}
                    >
                        loading {loadedCount}/{imageUrls.length}
                    </div>
                )}

                <ul className="menu">
                    <li>
                        <Link to="/digital">digital</Link>
                    </li>
                    <li>
                        <Link to="/">info</Link>
                    </li>
                </ul>
            </div>

            {/*             <img src="../content/Tampon-JB_GAMBINI.png" alt="Stamp JB Gambini 1905" className="stamp-above" />
 */}
        </div>
    );
}
